import React, { useEffect, useState } from "react";
import backicon from './../../../../../../Assets/icons/backIcon.svg'
import "./index.scss";
import { useLocation, useNavigate } from "react-router-dom";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import axiosInstance from "../../../../../services/api/API";
import { toastError, toastSuccess } from "../../../../../customComponents/customToast/Toast";
import { ToastContainer } from "react-toastify";
import { showCustomAlert } from "../../../../../customComponents/CustomSweetAlert";
import { showErrorAlert } from "../../../../../customComponents/CustomSweetAlert/errorsweetalert";
import Swal from "sweetalert2";
import Loader from "../../../../../customComponents/CustomLoader";



const AddNewPublisher = () => {
  const [formData, setFormData] = useState({});
  const [sourceOptions, setSourceOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const navigate = useNavigate();
  const authToken = localStorage.getItem("authToken"); 

  const [ userTypedd, setUserTypedd ] = useState([])
  const userType = localStorage.getItem("UserType")
  const location = useLocation()
  const businessPartnerId = location?.state?.data?.business_partner_id

  useEffect(() => {
    userTypedropdown()
  },[])

  const userTypedropdown = async () => {
    try{
      const response = await axiosInstance.get("/bp-onboard/bplist",{
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      })

      const data = response.data.data.data
      const userTypeOptions = data.map(user => ({
        value: user.onboard_id,
        label:user.bp_name,
      }))
      setUserTypedd(userTypeOptions)
    }catch(error) {
      console.log(error)
    }
  }

  const fetchSourceOptions = async () => {
    try {
     
      const business_partner_id = userType === "superadmin"?formData?.business_partner_id:businessPartnerId
      const response = await axiosInstance.post('/source/list', {
        business_partner_id,
        orderBy: 'source_id desc',
        page: 0,
        pageSize: 100,
      }, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const options = response.data.data.data.map(source => ({
        label: source.source_name,
        value: source.source_id,
      }));

      setSourceOptions(options);
    } catch (error) {
      console.error('Error fetching source options:', error);
    }
  };

  useEffect(() => {
    fetchSourceOptions();
  }, [formData?.business_partner_id]);

  const handleFormSubmit = async (formData) => {
    const errors = {};
    let isValid = true;
  
    // Validate required fields
    PublisherInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        }
      }
    });
  
    // If validation fails, set errors and return
    if (!isValid) {
      setValidationErrors(errors);
      return;
    }
  
    setLoading(true); // Start loading
  
    // Show confirmation alert before proceeding
    const result = await Swal.fire({
      title: "Confirmation",
      text: "Are you sure you want to add this record?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        try {
          const authToken = localStorage.getItem("authToken");
          const payload = {
            source_id: formData.source_name,
            publisher_name: formData.publisher_name,
            publisher_desc: formData.description,
            status: formData.status === "Active" ? 1 : 0,
          };
  
          // Add business partner ID based on user type
          if (userType === "superadmin") {
            payload.business_partner_id = formData.business_partner_id;
          } else {
            payload.business_partner_id = businessPartnerId;
          }
  
          // Make API call to create the publisher
          const response = await axiosInstance.post('/publisher/create', payload, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          });
  
          // Handle successful response
          if (response.status === 200) {
            Swal.fire({
              title: "Success",
              text: "Publisher added successfully!",
              icon: "success",
              confirmButtonText: "OK",
            }).then(() => {
              navigate('/admin/manage-campaign/publisher'); // Navigate after user clicks OK
            });
          }
        } catch (error) {
          console.error('Error adding publisher:', error);
  
          const errorMessage = error.response?.data?.message || "An error occurred while processing your request.";
          Swal.fire({
            title: "Something went wrong",
            text: errorMessage,
            icon: "error",
            confirmButtonText: "OK",
          });
        } finally {
          setLoading(false); // Stop loading
        }
      },
    });
  
    // Stop loading if user cancels
    if (!result.isConfirmed) {
      setLoading(false);
    }
  };
  

  const PublisherInputs = [
    ...(userType === "superadmin"
      ? [
          {
            name: "business_partner_id",
            label: "Business Partner",
            type: "dropdown",
            required: true,
            options: userTypedd,
            gridClass: "col-lg-4",
            validation: { required: true,
    
     },
          },
        ]
      : []),
    {
      name: "source_name",
      label: "Source Name",
      type: "dropdown",
      required: true,
      options: [], 
      gridClass: "col-lg-4",
      validation: { required: true,
        // pattern: /^[A-Za-z\s]*$/,
      
       },
    },
    {
      name: "publisher_name",
      label: "Publisher Name",
      placeholder:"Enter Publisher Name",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true,
        // pattern: /^[A-Za-z\s]*$/,
        pattern: /^[A-Za-z0-9-\s]*$/,
        message: "Special symbols are not allowed",
       },
    },
    
    {
      name: "description",
      label: "Description",
      placeholder:"Enter Publisher Description",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true },
    },
    {
      name: "status",
      label: "Status",
      type: "dropdown",
      required: true,
      options: [
        { id: 1, label: "Active", value: "Active" },
        { id: 0, label: "Inactive", value: "Inactive" },
      ],
      gridClass: "col-lg-4",
      validation: { required: true },
    },
  ];
  const backnavigation = () => {
    navigate("/admin/manage-campaign/publisher")
  }

  return (
    <>
     {loading ? (
        <Loader />
      ) : (
        <>
      <div onClick={backnavigation} className="backbutton mt-2 mb-2">
        <img src={backicon} alt="back" />
        <span className="backbtntitle">Add New Publisher</span>
      </div>
      <div className="form-container">
        <span className="cust-det-title mt-2 mb-2">
          Please Enter Publisher Details
        </span>
        <DynamicForm
          formConfig={PublisherInputs.map(input => 
            input.name === 'source_name' ? { ...input, options: sourceOptions } : input
          )}
          formData={formData}
          setFormData={setFormData}
          onSubmit={handleFormSubmit}
          validationErrors={validationErrors}
          setValidationErrors={setValidationErrors}
        />
      </div>
      <div className="btncontainer mt-3">
        <button
          onClick={() => handleFormSubmit(formData)}
          className="submit-btn"
        >
          Submit
        </button>
      </div></>
      )}
    </>
  );
};

export default AddNewPublisher;
